export default __webpack_public_path__ + "static/media/MZ.71ded24c.svg";